import { useEffect, useState } from "react";
import { fetchPath } from "../../config/defPath";

const getLoginContent = async (callback?: (data: any) => void) => {
    const url = `${fetchPath}/aguila/loyalty/tycpyp`;
    try {
        const response = await fetch(url);
        const json_response = await response.json();
        callback?.(json_response);
    } catch (err) {
        console.error(err);
    }
}

export const useViewData = () => {
    const [view, setView] = useState({
        data: null,
        isLoading: true,
    });

    useEffect(() => {
        getLoginContent(({ data }) => {
            setView({ data: data.login, isLoading: false });
            window.sessionStorage.setItem('TUP', JSON.stringify(data.tup));
        });
    }, []);

    return { view };
}